"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class SuccessResponse extends base_models_1.Serializable {
}
exports.default = SuccessResponse;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: 'Success status.' }),
    tslib_1.__metadata("design:type", Boolean)
], SuccessResponse.prototype, "success", void 0);
